import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // ✅ IMPORTED useNavigate
import "./SuperAdminPage.css";
import CompanySurveyDetails from "./CompanySurveyDetails";
import SurveyEditPanel from "./SurveyEditPanel";
import AdminSurveyDetailPage from './AdminSurveyDetailPage';
import { AuthProvider, useAuth } from '../context/AuthContext';
import AdminSurveyDetailPage5Dysfunction from './AdminSurveyDetailPage5Dysfunction';
import Global5SResponses from './Global5SResponses';
import GlobalVAKResponses from './GlobalVAKResponses';
import GlobalCPQResponses from "./GlobalCPQResponses";
import GlobalEMSResponses from "./GlobalEMSResponses";
import GlobalJHResponses from "./GlobalJHResponses";
import GlobalTKResponses from "./GlobalTKResponses";
import GlobalAOResponses from "./GlobalAOResponses";
import GlobalNSResponses from "./GlobalNSResponses";
import GlobalLOCOResponses from "./GlobalLOCOResponses";
import GlobalT90Responses from "./GlobalT90Responses";

export default function SuperAdminDashboard() {
  const navigate = useNavigate(); // ✅ INITIALIZED navigate

  const [activeTab, setActiveTab] = useState("companies"); // "companies" | "individuals"

  const [companies, setCompanies] = useState([]);
  const [surveys, setSurveys] = useState([]);

  // ✅ NEW STATES FOR INDIVIDUALS TAB
  const [individualSurveyTypes, setIndividualSurveyTypes] = useState([]);
  const [individualSurveys, setIndividualSurveys] = useState([]);
  const [selectedIndividualType, setSelectedIndividualType] = useState(null);

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [mode, setMode] = useState(null); // null | edit | view
  const [showAddModal, setShowAddModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const { user, loading } = useAuth();

  const [newCompany, setNewCompany] = useState({
    name: "", phone: "", email: "", address: "", created_by: user?.id
  });

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [availableSurveys, setAvailableSurveys] = useState([]);
  const [assignForm, setAssignForm] = useState({
    survey_fk: "", expires_at: "", response_expected: 0
  });

  // -------------------------
  // Fetch initial data based on Tab
  // -------------------------
  useEffect(() => {
    if (activeTab === "companies") {
      fetchCompanies();
      setSelectedIndividualType(null); // Clear individual selection
    } else {
      fetchIndividualSurveyTypes();
      setSelectedCompany(null); // Clear company selection
      setSelectedSurvey(null);
    }
  }, [activeTab]);

  const fetchCompanies = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/superadmin/companies`);
      setCompanies(res.data || []);
    } catch (err) {
      console.error("Failed to fetch companies", err);
    }
  };

  const fetchIndividualSurveyTypes = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/superadmin/individual-survey-types`);
      setIndividualSurveyTypes(res.data || []);
    } catch (err) {
      console.error("Failed to fetch individual survey types", err);
    }
  };

  const fetchSurveysForIndividualType = async (type) => {
    setSelectedIndividualType(type);
    setSelectedSurvey(null);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/superadmin/individual-surveys/${type.id}`);
      setIndividualSurveys(res.data || []);
    } catch (err) {
      console.error("Failed to fetch surveys for this type", err);
    }
  };

  const createCompany = async () => {
    if (!newCompany.name.trim()) { alert("Company name is required"); return; }
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/company`, newCompany);
      setShowAddModal(false);
      setNewCompany({ name: "", phone: "", email: "", address: "", created_by: user.id });
      fetchCompanies();
    } catch (err) {
      alert("Failed to create company");
    }
  };

  const fetchCompanySurveys = async (company) => {
    setSelectedCompany(company);
    setSelectedSurvey(null);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/superadmin/company/${company.id}/surveys`);
      const surveyList = res.data || [];
      setSurveys(surveyList);
      if (surveyList.length > 0) setSelectedSurvey(surveyList[0]);
    } catch (err) {
      console.error(err);
    }
  };

  const openAssignModal = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/survey/unassigned/${selectedCompany.id}`);
      setAvailableSurveys(res.data || []);
      setShowAssignModal(true);
    } catch (err) {
      alert("Failed to load surveys");
    }
  };

  const assignSurvey = async () => {
    if (!assignForm.survey_fk) { alert("Select survey"); return; }
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/survey/assign`, {
        ...assignForm,
        company_fk: selectedCompany.id,
        assigned_by: user.id || "SuperAdmin"
      });
      setShowAssignModal(false);
      fetchCompanySurveys(selectedCompany);
    } catch (err) {
      alert(err.response?.data?.error || "Assignment failed");
    }
  };

  const filteredCompanies = companies.filter((c) =>
    c.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="super-admin-container">

      {/* LEFT PANEL */}
      <div className="side-panel">

        <div className="panel-tabs">
          <button
            className={`tab-btn ${activeTab === "companies" ? "active" : ""}`}
            onClick={() => setActiveTab("companies")}
          >
            🏢 Companies
          </button>
          <button
            className={`tab-btn ${activeTab === "individuals" ? "active" : ""}`}
            onClick={() => setActiveTab("individuals")}
          >
            👤 Individuals
          </button>
        </div>

        {/* COMPANIES LEFT VIEW */}
        {activeTab === "companies" && (
          <>
            <div className="company-header" style={{ marginTop: '15px' }}>
              <h3>Directory</h3>
              <button className="add-company-btn" onClick={() => setShowAddModal(true)}>➕</button>
            </div>

            <div className="company-search">
              <input
                placeholder="Search company..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && filteredCompanies.length === 0 && (
                <div className="no-data">No matching companies found</div>
              )}
            </div>

            {companies.length === 0 && <div className="no-data">No companies found</div>}

            {filteredCompanies.map((c) => (
              <div
                key={c.id}
                className={`company-tile ${selectedCompany?.id === c.id ? "active" : ""}`}
                onClick={() => fetchCompanySurveys(c)}
              >
                {c.name}
              </div>
            ))}
          </>
        )}

        {/* INDIVIDUALS LEFT VIEW */}
        {activeTab === "individuals" && (
          <>
            <div className="company-header" style={{ marginTop: '15px' }}>
              <h3>Public Categories</h3>
            </div>

            {individualSurveyTypes.length === 0 && (
              <div className="no-data">No public survey types found</div>
            )}

            {individualSurveyTypes.map((type) => (
              <div
                key={type.id}
                className={`company-tile ${selectedIndividualType?.id === type.id ? "active" : ""}`}
                onClick={() => fetchSurveysForIndividualType(type)}
              >
                🌐 {type.name}
              </div>
            ))}
          </>
        )}
      </div>

      {/* RIGHT PANEL */}
      <div className="content-panel">

        {/* ------------------------- */}
        {/* RIGHT PANEL: COMPANIES    */}
        {/* ------------------------- */}
        {activeTab === "companies" && !selectedCompany && (
          <div className="empty-state">Select a company to view surveys</div>
        )}

        {activeTab === "companies" && selectedCompany && (
          <>
            <div className="dashboard-header">
              <h2>📋 {selectedCompany.name}</h2>
            </div>

            <div className="details-box">
              <CompanySurveyDetails companyId={selectedCompany.id} />
            </div>

            <div className="survey-header-row">
              <h3>📄 Assigned Surveys</h3>
              <button className="assign-btn" onClick={() => openAssignModal()}>➕ Assign Survey</button>
            </div>

            {surveys.length === 0 && <div className="no-data">No surveys assigned</div>}

            {surveys.map((s) => {
              const expanded = selectedSurvey?.survey_id === s.survey_id;
              return (
                <div key={s.survey_id} className={`survey-card ${expanded ? "active" : ""}`} onClick={() => setSelectedSurvey(expanded ? null : s)}>
                  <div className="survey-row">
                    <div>
                      <b>{s.survey_name}</b>
                      <div className="meta">
                        Expected: {s.responses_expected || "-"}<br />
                        Assigned: {new Date(s.assigned_on).toLocaleDateString()}
                      </div>
                    </div>
                    <div className={`status ${s.status}`}>{s.status}</div>
                  </div>

                  {expanded && (
                    <div className="survey-actions">
                      {/* ✅ NEW INVITE BUTTON (COMPANIES) */}
                      <button
                        className="btn-edit"
                        style={{ background: "#3498db" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/invite/${s.survey_id}/${selectedCompany.id}`);
                        }}
                      >
                        ✉️ Invite
                      </button>

                      <button className="btn-edit" onClick={(e) => { e.stopPropagation(); setMode("edit"); }}>✏ Edit</button>
                      <button className="btn-view" onClick={(e) => { e.stopPropagation(); setMode("view"); }}>📊 View Responses</button>
                    </div>
                  )}
                </div>
              );
            })}

            {selectedSurvey && mode === "edit" && (
              <SurveyEditPanel survey={selectedSurvey} companyId={selectedCompany.id} onSaved={() => fetchCompanySurveys(selectedCompany)} />
            )}
            {selectedSurvey && mode === "view" && (
              selectedSurvey.survey_type_fk === 2 ?
                <AdminSurveyDetailPage5Dysfunction surveyId={selectedSurvey.survey_id} companyId={selectedCompany.id} /> :
                <AdminSurveyDetailPage surveyId={selectedSurvey.survey_id} companyId={selectedCompany.id} />
            )}
          </>
        )}

        {/* ------------------------- */}
        {/* RIGHT PANEL: INDIVIDUALS  */}
        {/* ------------------------- */}
        {activeTab === "individuals" && !selectedIndividualType && (
          <div className="empty-state">Select a public category to view surveys</div>
        )}

        {activeTab === "individuals" && selectedIndividualType && (
          <>
            <div className="dashboard-header">
              <h2>👤 {selectedIndividualType.name} Surveys</h2>
            </div>

            <div className="details-box" style={{ marginBottom: '20px' }}>
              <p>Below are the master surveys under the <b>{selectedIndividualType.name}</b> category. Responses here are collected universally.</p>
            </div>

            {individualSurveys.length === 0 && <div className="no-data">No surveys found for this category.</div>}

            {individualSurveys.map((s) => {
              const uniqueId = s.survey_id || s.id;
              const expanded = selectedSurvey?.id === uniqueId;

              return (
                <div
                  key={uniqueId}
                  className={`survey-card ${expanded ? "active" : ""}`}
                  onClick={() => {
                    setSelectedSurvey(expanded ? null : { ...s, id: uniqueId });
                    setMode(null); // Reset mode when clicking a new card
                  }}
                >
                  <div className="survey-row">
                    <div>
                      <b>{s.survey_name || s.name}</b>
                      <div className="meta">
                        Survey Type ID: {s.survey_type_fk || s.type_id}
                      </div>
                    </div>
                    <div className="status active">Active</div>
                  </div>

                  {expanded && (
                    <div className="survey-actions">

                      {/* ✅ NEW INVITE BUTTON (INDIVIDUALS) */}
                      <button
                        className="btn-edit"
                        style={{ background: "#3498db" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          // Pass 0 as company ID for public individual surveys
                          navigate(`/invite/${uniqueId}/0`);
                        }}
                      >
                        ✉️ Invite
                      </button>

                      <button
                        className="btn-view"
                        onClick={(e) => {
                          e.stopPropagation();
                          setMode("view-individual");
                        }}
                      >
                        📊 View Global Responses
                      </button>
                    </div>
                  )}
                </div>
              );
            })}

            {selectedSurvey && mode === "view-individual" && (
              <>
                {selectedSurvey.survey_type_fk === 3 && (
                  <Global5SResponses surveyId={selectedSurvey.id} />
                )}

                {selectedSurvey.survey_type_fk === 4 && (
                  <GlobalVAKResponses surveyId={selectedSurvey.id} />
                )}
                {selectedSurvey.survey_type_fk === 5 && (
                  <GlobalCPQResponses surveyId={selectedSurvey.id} />
                )}
                {selectedSurvey.survey_type_fk === 6 && (
                  <GlobalEMSResponses surveyId={selectedSurvey.id} />
                )}
                {selectedSurvey.survey_type_fk === 7 && (
                  <GlobalJHResponses surveyId={selectedSurvey.id} />
                )}
                {selectedSurvey.survey_type_fk === 8 && (
                  <GlobalTKResponses surveyId={selectedSurvey.id} />
                )}
                {selectedSurvey.survey_type_fk === 9 && (
                  <GlobalAOResponses surveyId={selectedSurvey.id} />
                )}
                {selectedSurvey.survey_type_fk === 10 && (
                  <GlobalNSResponses surveyId={selectedSurvey.id} />
                )}
                {selectedSurvey.survey_type_fk === 11 && (
                  <GlobalLOCOResponses surveyId={selectedSurvey.id} />
                )}
                {selectedSurvey.survey_type_fk === 12 && (
                  <GlobalT90Responses surveyId={selectedSurvey.id} />
                )}
              </>
            )}
          </>
        )}
      </div>

      {/* MODALS */}
      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h2>➕ Add New Company</h2>
            <input placeholder="Company Name *" value={newCompany.name} onChange={(e) => setNewCompany({ ...newCompany, name: e.target.value })} />
            <input placeholder="Phone" value={newCompany.phone} onChange={(e) => setNewCompany({ ...newCompany, phone: e.target.value })} />
            <input placeholder="Email" value={newCompany.email} onChange={(e) => setNewCompany({ ...newCompany, email: e.target.value })} />
            <textarea placeholder="Address" rows={3} value={newCompany.address} onChange={(e) => setNewCompany({ ...newCompany, address: e.target.value })} />
            <div className="modal-actions">
              <button className="modal-cancel" onClick={() => setShowAddModal(false)}>Cancel</button>
              <button className="modal-save" onClick={createCompany}>Save Company</button>
            </div>
          </div>
        </div>
      )}

      {showAssignModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h2>📄 Assign Survey</h2>
            <select value={assignForm.survey_fk} onChange={(e) => setAssignForm({ ...assignForm, survey_fk: e.target.value })}>
              <option value="">Select Survey</option>
              {availableSurveys.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
            <input type="date" onChange={(e) => setAssignForm({ ...assignForm, expires_at: e.target.value })} />
            <input type="number" placeholder="Expected Responses" onChange={(e) => setAssignForm({ ...assignForm, response_expected: e.target.value })} />
            <div className="modal-actions">
              <button className="modal-cancel" onClick={() => setShowAssignModal(false)}>Cancel</button>
              <button className="modal-save" onClick={assignSurvey}>Assign</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}